<template>
    <div>
        <div class="tw-mb-8">
            <div
                class="tw-grid tw-grid-cols-12 tw-bg-gray-50 tw-pt-3 tw-pb-3 tw-mb-8 tw-rounded-lg tw-uppercase"
            >
                <div class="tw-col-span-9 tw-font-semibold tw-pl-4">
                    {{ $t("teamDashboard.feedbackTitle") }}
                </div>
                <div class="tw-col-span-3 color-grey">
                    {{ $t("teamDashboard.feedbackStatus") }}
                </div>
            </div>
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!userList.length" class="tw-text-gray-400">
                {{ $t("teamDashboard.feedbackEmpty") }}
            </div>

            <div v-else>
                <div v-for="employee in userList" :key="employee._id">
                    <div class="tw-grid tw-grid-cols-12 tw-mb-4">
                        <div
                            class="tw-col-span-9 tw-items-center tw-flex tw-space-x-6 tw-pt-2 tw-pb-2"
                        >
                            <l-profile-picture :user="employee.user" size="xm" />

                            <span>
                                <strong>{{ employee.user.fullname }}</strong>
                                <br />
                                <span v-if="employee.received < 2" class="color-grey">
                                    {{ $t(`feedback.analytics.userlist.noRecentFeedback`) }}
                                </span>
                                <span
                                    v-else-if="employee.stats && employee.stats.feedbackStreak"
                                    class="color-grey"
                                >
                                    {{
                                        $t(`feedback.analytics.userlist.isOnStreak`, [
                                            employee.stats.feedbackStreak || 0,
                                        ])
                                    }}
                                </span>
                                <span v-else class="color-grey">
                                    {{ employee.user.teamRole.title }}
                                </span>
                            </span>
                        </div>
                        <div class="tw-col-span-3 tw-flex tw-items-center tw-text-right">
                            <div>
                                <span
                                    v-b-popover.hover.top="
                                        $t(`feedback.analytics.userlist.received`)
                                    "
                                    class="label tw-mr-2"
                                    :class="employee.received ? 'label-success' : 'label-default'"
                                >
                                    <i class="fal fa-envelope tw-mr-2"></i> {{ employee.received }}
                                </span>
                                <span
                                    v-b-popover.hover.top="$t(`feedback.analytics.userlist.sent`)"
                                    class="label tw-mr-2"
                                    :class="employee.sent ? 'label-success' : 'label-default'"
                                >
                                    <i class="fal fa-paper-plane tw-mr-2"></i> {{ employee.sent }}
                                </span>
                                <span
                                    v-b-popover.hover.top="
                                        $t(`feedback.analytics.userlist.requested`)
                                    "
                                    class="label tw-mr-2"
                                    :class="employee.requested ? 'label-success' : 'label-default'"
                                >
                                    <i class="fal fa-repeat tw-mr-2"></i> {{ employee.requested }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LSkeletonLoader from "@/components/LSkeletonLoader";
import LProfilePicture from "@/components/LProfilePicture";

export default {
    components: {
        LSkeletonLoader,
        LProfilePicture,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            types: ["goalTeam", "goalLocalTeam", "goalUser"],
        };
    },
    computed: {
        ...mapGetters({
            userList: "feedback/stats/userList",
        }),
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.isLoading = true;
            await this.$store
                .dispatch({
                    type: "feedback/stats/getUserlist",
                    payload: {
                        query: {
                            filters: {
                                admin: [{ _id: "reportsSearch" }],
                                periods: [
                                    {
                                        start: this.$moment().subtract(3, "months"),
                                        end: this.$moment(),
                                    },
                                ],
                            },
                        },
                    },
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
